export default __webpack_public_path__ + "77d8d66dbab8cd2d1db284ce9176baa8.png";